import { Link, Outlet } from 'react-router-dom';
import { FaPhoneAlt } from "react-icons/fa";
import { AiFillFacebook } from "react-icons/ai";
import logo from '../../assets/logo.jpeg';
import './navbar.styles.css'

const NavBar = () => {
    return (
        <>
            <header className='navbar-container'>
                <nav>
                    <div className='left'>
                        <div>
                            <Link className='link-img' to='/'>
                                <img src={logo} alt='Company Logo' />
                            </Link>
                        </div>
                        <div>
                            <Link className='link-text' to='/'>Home</Link>
                        </div>
                        <div>
                            <Link className='link-text' to='/book-now'>Book Now</Link>
                        </div>
                    </div>
                    <div className='right'>
                        <Link className='link-text right-button' to='/book-now'>Book Now</Link>
                    </div>
                </nav>
            </header>
            <section className='body-content'>
                <Outlet />
            </section>
            <footer className='footer-container'>
                <div className='footer-content'>
                    <div className='contacts'>
                        <div className='social'>
                            <a href='https://www.facebook.com/profile.php?id=61559768745522'><AiFillFacebook className='facebook-icon' /></a>
                        </div>
                        <div className='email'>yenroautomotive@yahoo.com</div>
                        <div className='phone'><FaPhoneAlt /> <span>0466 5646 89</span></div>
                    </div>
                    <div>
                        <Link className='link-text right-button' to='/book-now'>Book Now</Link>
                    </div>
                </div>
            </footer>
        </>
    );
}

export default NavBar;